import { useEffect, useState } from "react";
import Step from "./Step";
import Dollars from "../Dollars";

export default function AboutMatchExpressions({ onNext, index }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    fetch("/api/on_ramp/payee_with_transactions")
      .then(response => response.json())
      .then(data => {
        setData(data)
      });
  }, []);

  if (!data) return "";
  const { payee, count, total, transactions, earliest_date } = data;

  return <Step index={index} title="Match Expressions" canProceed>
    <p>
      Every Payee has a <strong>Match Expression</strong> that is used to determine
      which other transactions should be categorized the same way. For example, here
      the payee <strong>{payee.name}</strong> has been categorized
      as <strong>{payee.category}</strong>. Any other transactions matching the
      expression <strong>/{payee.regex}/</strong> will be categorized the same way.
    </p>
    <p>
      Here are other transations that match this Match Expression and belong to the same
      payee:
    </p>
    <table className={"table table-sm table-striped"}>
      <thead>
        <tr>
          <th>Date</th>
          <th>Description</th>
          <th className={"text-end"}>Amount</th>
        </tr>
      </thead>
      <tbody>
        {transactions.map((tx, i) => (
          <tr key={i}>
            <td>{tx.date}</td>
            <td>{tx.description}</td>
            <td className={"text-end"}><Dollars amount={tx.amount} /></td>
          </tr>
        ))}
      </tbody>
      <tfoot className={"table-primary"}>
        <tr>
          <td colSpan={2}>Number of Matching transactions</td>
          <td className={"text-end"}>{count}</td>
        </tr>
        <tr>
          <td colSpan={2}>Total since {earliest_date}</td>
          <td className={"text-end"}><Dollars amount={total} /></td>
        </tr>
      </tfoot>
    </table>
    <p>
      This Match Expression uses a technique called <em>Regular Expressions</em> to
      match other transactions. Regular expressions are very powerful, but are sometimes
      difficult to understand. Fortunately, our AI is really good at this and determines
      the regular expressions for you.
    </p>
    <p>
      Artificial Intelligence can sometimes guess wrong. You will be able to edit your Payee's name,
      category and match expression to impreove the accuracy of your spending analysis.
    </p>
  </Step>
}